import { forwardRef } from "react";

import { Circle, type CircleProps } from "@eisox/design-system";
import { AirHandlerUnitIcon } from "@eisox/icons";

const AirHandlerUnit = forwardRef<HTMLDivElement, CircleProps>(
  ({ size = 20, backgroundColor = "blue", color = "white", ...props }, ref) => (
    <Circle.Root {...props} ref={ref} size={size} backgroundColor={backgroundColor} color={color}>
      <AirHandlerUnitIcon />
    </Circle.Root>
  ),
);

AirHandlerUnit.displayName = "AirHandlerUnit";

export { AirHandlerUnit };
